import React, { useState, useEffect, useRef } from 'react'
import VisualizacaoPadrao from '../../../../components/VisualizacaoPadrao'
import { useParams } from "react-router-dom";
import { get, visualizar } from '../../../../util/AcessoApi'
import { ordenarArrayObj } from '../../../../util/FuncoesComuns';
import Medidor from '../../../../components/GaugeChart';
import ReactToPrint from 'react-to-print';
import { meses } from '../../../../util/Utilitarios';
import { Imprimir } from '../../../../components/Acoes';
import '../css/formulario.css';
import { TIPO_PERGUNTA } from '../../../../util/Enums';
//import { TIPO_PERGUNTA } from '../../../../assets/img/logo-equipe.png';

const Visualizacao = (props) => {
    const reference = useRef();
    const btnPrint = useRef();
    const actualDate = new Date();
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [agrupamentos, setAgrupamentos] = useState([])
    let { id } = useParams()


    useEffect(_ => {
        Promise.resolve(get(`/preanestesico/consultapreanestesico/${id || 0}`)).then(obj => {
            var { agrupamentos, ...paciente } = obj;
            paciente.nivel_dor = paciente.nivel_dor;
            setValoresIniciais({ agrupamentos: agrupamentos, ...paciente });
            setAgrupamentos(agrupamentos.flatMap(x => x.questoes))
        })
    }, [id])

    return <div className="card" ref={reference}>
        <ReactToPrint
            trigger={() => <button className={"hidden d-none"} ref={btnPrint} />}
            content={() => reference.current} pageStyle={`@page { size: ${props.orientacao || 'a4 auto'} }`} />
        {
            <div className="card-body">
                <div className={'d-none-print colored'}>
                    <div className={'col-12 row mr-0 ml-0 mb-1 pr-0 pl-0'}>
                        <div className="col-12 row-space-between pr-0 pl-0">
                            <div>
                            </div>
                            <div className="text-right">
                                <Imprimir action={() => btnPrint.current.click()} />
                            </div>
                        </div>
                        <div className="col-12 titulo-visualizacao">
                            <h5>{'Ficha'}</h5>
                            <h6>{actualDate.getDate().toString().padStart(2, '0') + ' de ' + (meses[actualDate.getMonth() + 1] || meses.default) + ' de ' + actualDate.getFullYear()}</h6>
                        </div>
                    </div>
                </div>
                <div className="form-container">
                    <div className='row'>
                        <div className='col-6'>
                            <div><img className='logo-ficha' src={require('../../../../assets/img/cropped-logo-equipe.png')} /></div>
                            <div className="header">Ficha de Avaliação Pré-Anestésica</div>
                            <div className="sub-header">Resolução CFM 2.174 / 2017</div>
                            <div className="text-container data-consulta" style={{ flex: 1 }}>
                                <span className="label"><b>Data: </b></span>
                                <span className="underline">{valoresIniciais?.data_registro_formatada || ''}</span>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='dados-paciente'>
                                <div className='dados-paciente-titulo'><span>Preencher quando não houver etiqueta</span></div>
                                <div className='p-1'>
                                    <div className="text-container dados-paciente-label">
                                        <span className="label"><b>Paciente: </b></span>
                                        <span className="underline">{valoresIniciais?.paciente?.label || ''}</span>
                                    </div>
                                    <div className='dados-paciente-label flex-row'>
                                        <div className="text-container" style={{ flex: 2 }}>
                                            <span className="label"><b>Data Nascimento: </b></span>
                                            <span className="underline">{valoresIniciais?.data_nascimento || ''}</span>
                                        </div>
                                        <div className="text-container" style={{ flex: 1 }}>
                                            <span className="label"><b>Idade: </b></span>
                                            <span className="underline">{valoresIniciais?.idade || ''}</span>
                                        </div>
                                    </div>
                                    <div className="text-container dados-paciente-label">
                                        <span className="label"><b>Nome Responsável ou CPF: </b></span>
                                        <span className="underline">{valoresIniciais?.responsavel_nome || valoresIniciais?.responsavel_identificacao}</span>
                                    </div>
                                    <div className='dados-paciente-label flex-row'>
                                        <div className="text-container" style={{ flex: 2 }}>
                                            <span className="label"><b>Operadora de Saúde: </b></span>
                                            <span className="underline">{valoresIniciais?.operadora_saude_nome || ''}</span>
                                        </div>
                                    </div>
                                    <div className="text-container dados-paciente-label">
                                        <span className="label"><b>Estabelecimento de Saúde: </b></span>
                                        <span className="underline">{valoresIniciais?.estabelecimento_saude_nome || ''}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='form-table flex-row'>
                        <div className='info' style={{ flex: 2 }}>
                            <div className='title'>PESO(kg)</div>
                            <div className='value'>
                                <div>{valoresIniciais?.peso || ''}</div>
                            </div>
                        </div>
                        <div className='info' style={{ flex: 3 }}>
                            <div className='title'>ALTURA(cm)</div>
                            <div className='value'>{valoresIniciais?.altura || ''}</div>
                        </div>
                        <div className='info' style={{ flex: 3 }}>
                            <div className='title'>PA</div>
                            <div className='value'>{valoresIniciais?.pressao_arterial || ''}</div>
                        </div>
                        <div className='info' style={{ flex: 2 }}>
                            <div className='title'>FC</div>
                            <div className='value'>{valoresIniciais?.frequencia_cardiaca || ''}</div>
                        </div>
                        <div className='info' style={{ flex: 4 }}>
                            <div className='title'>JEJUM(h)</div>
                            <div className='value'>
                                <div style={{ flexDirection: 'column', display: 'flex', textAlign: 'left' }}>
                                    <div style={{ borderBottom: '1px solid #000', paddingBottom: '5px', paddingTop: '10px' }} className="text-container">
                                        <span className="label">Sólidos: {valoresIniciais?.jejum_solidos_horas ? valoresIniciais?.jejum_solidos_horas + ' hora(s)' : ''}</span>
                                    </div>
                                    <div style={{ paddingBottom: '5px', paddingTop: '10px' }} className="text-container">
                                        <span className="label">Líquidos: {valoresIniciais?.jejum_liquidos_horas ? valoresIniciais?.jejum_liquidos_horas + ' hora(s)' : ''}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='info' style={{ flex: 6 }}>
                            <div className='title'>NÍVEL DE DOR</div>
                            <div className='value'>
                                <div className='dor-container'>
                                    <div className={`dor-linha ` + (valoresIniciais.nivel_dor == 0 ? 'marked' : '')}><span className='icone'>😁</span><span>0</span></div>
                                    <div className={`dor-linha ` + (valoresIniciais.nivel_dor == 1 ? 'marked' : '')}><span className='icone'>🙂</span><span>1</span></div>
                                    <div className={`dor-linha ` + (valoresIniciais.nivel_dor == 2 ? 'marked' : '')}><span className='icone'>😐</span><span>2</span></div>
                                    <div className={`dor-linha ` + (valoresIniciais.nivel_dor == 3 ? 'marked' : '')}><span className='icone'>🙁</span><span>3</span></div>
                                    <div className={`dor-linha ` + (valoresIniciais.nivel_dor == 4 ? 'marked' : '')}><span className='icone'>😟</span><span>4</span></div>
                                    <div className={`dor-linha ` + (valoresIniciais.nivel_dor == 5 ? 'marked' : '')}><span className='icone'>😫</span><span>5</span></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='form-table flex-row'>
                        <div className='info' style={{ flex: 1 }}>
                            <div className='title'>CIRURGIA/PROCEDIMENTO</div>
                            <div className='value fs-13 text-left procedimento-text'>{valoresIniciais?.procedimentos?.map(x => x.descricao).join(', ')}</div>
                        </div>
                    </div>
                    {/* <QuestionForm /> */}
                    <div className='form-table'>
                        <div className='info' style={{ flex: 1 }}>
                            {/* <div className='title'>FORMULÁRIO</div> */}
                            <div className='value'>
                                <div className='question-container'>
                                    {
                                        valoresIniciais?.agrupamentos ? valoresIniciais?.agrupamentos.map((agrupamento, aggIdx, arrAgg) => {
                                            let ocuparMenos = false;
                                            let aggLength = arrAgg.length;

                                            if (agrupamento.questoes && agrupamento.questoes?.length <= 2)
                                                if ((aggIdx < (aggLength - 1) && arrAgg[aggIdx + 1].questoes?.length <= 2) || (aggIdx > 0 && arrAgg[aggIdx - 1].questoes?.length <= 2))
                                                    ocuparMenos = true;



                                            return <>
                                                <div className='title'>
                                                    {agrupamento.descricao}
                                                </div>
                                                {
                                                    agrupamento.questoes ? agrupamento.questoes.map((questao) => {
                                                        let arrOp3Caracteres = [];
                                                        let ajustarOpcoes = false;

                                                        if (questao.tipo_pergunta != TIPO_PERGUNTA.COMENTARIO) {
                                                            arrOp3Caracteres = questao?.opcoes?.filter(x => x.descricao.length <= 3) || [];
                                                            // console.log('arrOp3Caracteres: ', arrOp3Caracteres);
                                                            ajustarOpcoes = arrOp3Caracteres.length == questao?.opcoes?.length || questao?.opcoes?.length <= 3;
                                                        }

                                                        return <div className='text-left p-1 question'>
                                                            <div className='row-space-between'>
                                                                <span className='fs-13 mb-1'>{questao.descricao}</span>
                                                                {questao.mostrar_nao_possui ? <div className="no-wrap checkbox-container">
                                                                    <div className={`checkbox ${questao.nao_possui ? 'checked' : ''}`}></div>
                                                                    <span>Negativo</span>
                                                                </div> : <></>}
                                                            </div>

                                                            {questao.tipo_pergunta == TIPO_PERGUNTA.COMENTARIO ?
                                                                <div className='textarea'><span className='span-obs'>{questao.observacao}</span></div>
                                                                : <>
                                                                    <div className='options-form' style={ajustarOpcoes ? { gridTemplateColumns: questao?.opcoes?.length >= 5 ? 'repeat(5, 1fr)' : `repeat(${questao?.opcoes?.length}, 1fr)` } : {}}>
                                                                        {
                                                                            questao?.opcoes ? questao.opcoes.map((opcao) => {
                                                                                return <div className="checkbox-container">
                                                                                    <div className={`checkbox ${opcao.marcado ? 'checked' : ''}`}></div>
                                                                                    <span>{opcao.descricao}</span>
                                                                                </div>
                                                                            }) : <></>
                                                                        }
                                                                    </div>
                                                                    <div className='div-span-obs'>
                                                                        <span className='span-obs'>{questao.observacao || ""}</span>
                                                                    </div>
                                                                </>}

                                                        </div>
                                                    }) : <></>
                                                }
                                            </>

                                        }) : <></>
                                    }
                                    <div className='text-left p-1 question'>
                                        <div className='row-space-between'>
                                            <span className='fs-13 mb-1'>Liberado para Cirurgia?</span>
                                        </div>
                                        <>
                                            <div className='options-form' style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
                                                <div className="checkbox-container">
                                                    <div className={`checkbox ${valoresIniciais.liberado ? 'checked' : ''}`}></div>
                                                    <span>Sim</span>
                                                </div>
                                                <div className="checkbox-container">
                                                    <div className={`checkbox ${(valoresIniciais.liberado == false) ? 'checked' : ''}`}></div>
                                                    <span>Não</span>
                                                </div>
                                            </div>
                                        </>
                                    </div>
                                </div>

                                {/* {
                                    agrupamentos ? agrupamentos.map((questao) => {
                                        return <div className='text-left p-1 question'>
                                            <span className='fs-13 mb-1'>{questao.descricao}</span>
                                            {questao.tipo_pergunta == TIPO_PERGUNTA.COMENTARIO ?
                                                <div className='textarea'></div>
                                                : <div className='options-form'>
                                                    {
                                                        questao?.opcoes ? questao.opcoes.map((opcao) => {
                                                            return <div className="checkbox-container">
                                                                <div className="checkbox checked"></div>
                                                                <span>{opcao.descricao}</span>
                                                            </div>
                                                        }) : <></>
                                                    }
                                                </div>}

                                        </div>
                                    }) : <></>} */}
                            </div>
                        </div>
                    </div>

                    <div className='form-table flex-row'>
                        <div className='info' style={{ flex: 1 }}>
                            <div className='title'>OBSERVAÇÕES GERAIS</div>
                            <div className='value p-1 obs-geral text-left' style={{ minHeight: 60 }}>
                                <span className='span-obs'>{valoresIniciais.observacao}</span>
                            </div>
                        </div>
                    </div>
                    <div className='row mt-1'>
                        <div className='col-12'>
                            <div className="text-container" style={{ flex: 1 }}>
                                <span className="label"><b>Anestesiologista: </b></span>
                                <span className="underline">{valoresIniciais.anestesiologista || ''}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    </div >
}

export default Visualizacao